import { useEffect } from 'react';

/* ----------------------------------------------------------------------------
 * useBodyScrollLock — freeze <body> scroll while `locked` (a mobile drawer or
 * bottom-sheet is open) so the page behind the overlay can't scroll. Restores
 * the previous inline value on release.
 * -------------------------------------------------------------------------- */
export function useBodyScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, [locked]);
}
